"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _CssBaseline = _interopRequireDefault(require("@mui/material/CssBaseline"));
var _xDatePickers = require("@mui/x-date-pickers");
var _AdapterMoment = require("@mui/x-date-pickers/AdapterMoment");
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _moment = _interopRequireDefault(require("moment"));
var _react2 = _interopRequireDefault(require("react"));
var _SnackbarProvider = _interopRequireDefault(require("../Components/Snackbars/SnackbarProvider.js"));
var _ThemeProvider = _interopRequireDefault(require("../Theme/ThemeProvider.js"));
var _UnhandledErrorView = _interopRequireDefault(require("../Views/Error/UnhandledErrorView.js"));
require("@fontsource/roboto/300.css");
require("@fontsource/roboto/400.css");
require("@fontsource/roboto/500.css");
require("@fontsource/roboto/700.css");
require("moment/locale/en-gb");
require("moment/locale/en-au");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * App entrypoint
 *
 * Renders the root-level application component.
 *
 * @package HOPS
 * @subpackage App
 * @copyright Heritage Operations Processing Limited
 */const HOPSApplication = ({
  children,
  orgTheme
}) => {
  // Passive provision for future scope to get this from Registration
  const [locale] = _react2.default.useState("en-gb");

  /**
   * Configure Moment to use the client locale.
   * Affects e.g. Material UI Pickers calendar views.
   * 
   * Don't assume locale-specific conventions such as first day of the week.
   */
  if (_moment.default.locale() !== locale) {
    _moment.default.locale(locale);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Sentry.ErrorBoundary, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_UnhandledErrorView.default, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_xDatePickers.LocalizationProvider, {
      dateAdapter: _AdapterMoment.AdapterMoment,
      adapterLocale: locale,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.StyledEngineProvider, {
        injectFirst: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ThemeProvider.default, {
          orgTheme: orgTheme,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CssBaseline.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SnackbarProvider.default, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Sentry.ErrorBoundary, {
              fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_UnhandledErrorView.default, {}),
              children: children
            })
          })]
        })
      })
    })
  });
};
var _default = exports.default = HOPSApplication;